import { render, staticRenderFns } from "./DetailCommissionModal.vue?vue&type=template&id=7647e396"
import script from "./DetailCommissionModal.vue?vue&type=script&lang=js"
export * from "./DetailCommissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports